"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.DashboardLayoutSectionBuilder = void 0;
var tslib_1 = require("tslib");
// (C) 2019-2021 GoodData Corporation
var ts_invariant_1 = tslib_1.__importDefault(require("ts-invariant"));
var identity_1 = tslib_1.__importDefault(require("lodash/identity"));
var isArray_1 = tslib_1.__importDefault(require("lodash/isArray"));
var difference_1 = tslib_1.__importDefault(require("lodash/difference"));
var sdk_backend_spi_1 = require("@gooddata/sdk-backend-spi");
var sdk_backend_base_1 = require("@gooddata/sdk-backend-base");
var item_1 = require("./item");
/**
 * @alpha
 */
var DashboardLayoutSectionBuilder = /** @class */ (function () {
    function DashboardLayoutSectionBuilder(sectionIndex, getSectionFacade, setLayout) {
        var _this = this;
        this.sectionIndex = sectionIndex;
        this.getSectionFacade = getSectionFacade;
        this.setLayout = setLayout;
        this.removeEmptyItems = function () {
            return _this.removeItems(function (items) { return items.filter(function (item) { return item.isEmpty(); }); });
        };
    }
    /**
     * Creates an instance of DashboardLayoutSectionBuilder for particular layout item.
     *
     * @param item - item to modify
     */
    DashboardLayoutSectionBuilder.for = function (layoutBuilder, sectionIndex) {
        var _a;
        ts_invariant_1.default(sdk_backend_spi_1.isDashboardLayoutSection((_a = layoutBuilder.facade().sections().section(sectionIndex)) === null || _a === void 0 ? void 0 : _a.raw()), "Provided data must be IDashboardLayoutSection!");
        return new DashboardLayoutSectionBuilder(sectionIndex, function () { return layoutBuilder.facade().section(sectionIndex); }, function (layout) { return layoutBuilder.setLayout(layout); });
    };
    DashboardLayoutSectionBuilder.prototype.header = function (valueOrUpdateCallback) {
        return this.setSection(function (section) { return (tslib_1.__assign(tslib_1.__assign({}, section), { header: sdk_backend_base_1.resolveValueOrUpdateCallback(valueOrUpdateCallback, section.header) })); });
    };
    DashboardLayoutSectionBuilder.prototype.addItem = function (xlSize, create, index) {
        if (create === void 0) { create = identity_1.default; }
        if (index === void 0) { index = this.facade().items().count(); }
        var emptyItem = {
            type: "IDashboardLayoutItem",
            size: {
                xl: xlSize,
            },
        };
        this.setSection(function (section) {
            var updatedItems = tslib_1.__spreadArrays(section.items);
            updatedItems.splice(index, 0, emptyItem);
            return tslib_1.__assign(tslib_1.__assign({}, section), { items: updatedItems });
        });
        item_1.DashboardLayoutItemBuilder.for(this, index).modify(create);
        return this;
    };
    DashboardLayoutSectionBuilder.prototype.modifyItem = function (index, modify) {
        var itemFacade = this.facade().items().item(index);
        ts_invariant_1.default(itemFacade, "Cannot modify the item - item at index " + index + " does not exist!");
        item_1.DashboardLayoutItemBuilder.for(this, index).modify(modify);
        return this;
    };
    DashboardLayoutSectionBuilder.prototype.removeItem = function (index) {
        var itemFacade = this.facade().items().item(index);
        ts_invariant_1.default(itemFacade, "Cannot remove the item - item at index " + index + " does not exist!");
        return this.setSection(function (section) {
            var updatedItems = tslib_1.__spreadArrays(section.items);
            updatedItems.splice(index, 1);
            return tslib_1.__assign(tslib_1.__assign({}, section), { items: updatedItems });
        });
    };
    DashboardLayoutSectionBuilder.prototype.moveItem = function (fromIndex, toIndex) {
        var itemFacade = this.facade().item(fromIndex);
        ts_invariant_1.default(itemFacade, "Cannot move the item - item at index " + fromIndex + " does not exist!");
        var maxToIndex = Math.min(toIndex, this.facade().items().count() - 1);
        this.removeItem(fromIndex);
        this.addItem(itemFacade.sizeForScreen("xl"), function (c) { return c.setItem(itemFacade.raw()); }, maxToIndex);
        return this;
    };
    DashboardLayoutSectionBuilder.prototype.removeItems = function (selector) {
        if (selector === void 0) { selector = function (items) { return items.all(); }; }
        var itemsToRemove = selector(this.facade().items());
        if (isArray_1.default(itemsToRemove)) {
            this.setSection(function (section) {
                var updatedItems = difference_1.default(section.items, itemsToRemove.map(function (r) { return r.raw(); }));
                return tslib_1.__assign(tslib_1.__assign({}, section), { items: updatedItems });
            });
        }
        else if (itemsToRemove) {
            this.removeItem(itemsToRemove.index());
        }
        return this;
    };
    DashboardLayoutSectionBuilder.prototype.modifyItems = function (modify, selector) {
        var _this = this;
        if (selector === void 0) { selector = function (items) { return items.all(); }; }
        var itemsToModify = selector(this.facade().items());
        if (isArray_1.default(itemsToModify)) {
            itemsToModify.forEach(function (item) {
                _this.modifyItem(item.index(), modify);
            });
        }
        else if (itemsToModify) {
            this.modifyItem(itemsToModify.index(), modify);
        }
        return this;
    };
    DashboardLayoutSectionBuilder.prototype.setSection = function (valueOrUpdateCallback) {
        var _this = this;
        this.setLayout(function (layout) {
            var updatedRows = tslib_1.__spreadArrays(layout.sections);
            updatedRows[_this.sectionIndex] = sdk_backend_base_1.resolveValueOrUpdateCallback(valueOrUpdateCallback, _this.build());
            return tslib_1.__assign(tslib_1.__assign({}, layout), { sections: updatedRows });
        });
        return this;
    };
    DashboardLayoutSectionBuilder.prototype.facade = function () {
        return this.getSectionFacade();
    };
    DashboardLayoutSectionBuilder.prototype.modify = function (modifications) {
        modifications(this, this.facade());
        return this;
    };
    DashboardLayoutSectionBuilder.prototype.build = function () {
        return this.facade().raw();
    };
    return DashboardLayoutSectionBuilder;
}());
exports.DashboardLayoutSectionBuilder = DashboardLayoutSectionBuilder;
//# sourceMappingURL=section.js.map